export function createReducer(functionMap, initialState = {}) {
    return (state, action) =>  {
        if(functionMap.hasOwnProperty(action.type)) {
            return functionMap[action.type](state, action)
        }

        if (state)
            return state
        return initialState
    }
}




// WEBPACK FOOTER //
// ./src/reducers/utils.js